const team = [
  { 
    initials: "TT", 
    name: "Travis Thompson", 
    role: "Founder & CEO", 
    bio: "Security technology visionary building the future of patrol management in South Africa."
  },
  { 
    initials: "KJP", 
    name: "Kyle Jean Pierre", 
    role: "Head of Technology", 
    bio: "Full-stack architect specialising in real-time geospatial systems and biometric AI."
  },
  { initials: "SvdM", name: "Sarah van der Merwe", role: "Head of Operations", bio: "15 years in SA security industry. Registered professional. Operational excellence champion." },
  { initials: "JN", name: "James Nkosi", role: "Client Success Manager", bio: "Dedicated to ensuring every client maximises their SecureFlex deployment." },
];

const TeamSection = () => (
  <section id="team" className="py-24">
    <div className="mx-auto max-w-7xl px-6">
      <p className="text-sm font-semibold tracking-widest text-primary">Our Team</p>
      <h2 className="mt-2 text-3xl font-bold md:text-5xl">THE PEOPLE BEHIND SECUREFLEX</h2>
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {team.map((t, i) => (
          <div key={t.name} className="rounded-xl border border-border bg-card p-8 text-center animate-fade-in" style={{ animationDelay: `${i * 0.1}s`, animationFillMode: "backwards" }}>
            <div className="mx-auto mb-4 flex h-24 w-24 items-center justify-center rounded-full bg-primary overflow-hidden text-xl font-bold text-primary-foreground border-2 border-primary/20">
              {t.initials}
            </div>
            <h3 className="text-lg font-bold">{t.name}</h3>
            <p className="text-sm font-medium text-primary">{t.role}</p>
            <p className="mt-3 text-sm text-muted-foreground">{t.bio}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TeamSection;
